export default "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_28_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><circle id=\"XMLID_29_\" class=\"st1\" cx=\"45\" cy=\"19\" r=\"19\"/><circle id=\"XMLID_1_\" class=\"st1\" cx=\"19.3\" cy=\"44.7\" r=\"19\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ./static/symbols/1.svg
// module id = 49
// module chunks = 0